import * as React from 'react';
import { useBacs } from '../../hooks/useBacs';
import { useDepots } from '../../hooks/useDepots';
import { useData } from '../../core/context/ProvidersContext';
import { IBac } from '../../models';
import styles from './AdminPanel.module.scss';

const EMPTY_BAC: Omit<IBac, 'Id' | 'DepotTitle'> = {
  Title: '', DepotId: 0, VolumeUtile: 0, RestrictionClients: null,
  PointDepot: false, DetailsDepot: '', InfoClients: false, DetailsClients: '',
  Commentaire: '',
};

export const BacsManager: React.FC = () => {
  const data = useData();
  const { bacs, loading, refresh } = useBacs();
  const { depots } = useDepots();
  const [draft, setDraft] = React.useState<Omit<IBac, 'Id' | 'DepotTitle'>>(EMPTY_BAC);
  const [filter, setFilter] = React.useState<number | ''>('');

  const filtered = filter ? bacs.filter(b => b.DepotId === filter) : bacs;

  const handleAdd = async (): Promise<void> => {
    if (!draft.Title || !draft.DepotId) return;
    await data.addBac(draft);
    setDraft(EMPTY_BAC);
    refresh();
  };

  const handleDelete = async (id: number): Promise<void> => {
    if (!confirm('Supprimer ce bac ?')) return;
    await data.deleteBac(id);
    refresh();
  };

  if (loading) return <div className={styles.loading}>Chargement…</div>;

  return (
    <div className={styles.crud}>
      <h3>Bacs ({filtered.length})</h3>
      <div className={styles.filterRow}>
        <select
          className={styles.input}
          value={filter}
          onChange={e => setFilter(e.target.value ? Number(e.target.value) : '')}
        >
          <option value="">Tous les dépôts</option>
          {depots.map(d => <option key={d.Id} value={d.Id}>{d.Title}</option>)}
        </select>
      </div>
      <div className={styles.addRow}>
        <input
          className={styles.input}
          placeholder="Identifiant"
          value={draft.Title}
          onChange={e => setDraft({ ...draft, Title: e.target.value })}
        />
        <select
          className={styles.input}
          value={draft.DepotId}
          onChange={e => setDraft({ ...draft, DepotId: Number(e.target.value) })}
        >
          <option value={0}>— Dépôt —</option>
          {depots.map(d => <option key={d.Id} value={d.Id}>{d.Title}</option>)}
        </select>
        <input
          className={styles.input}
          type="number"
          placeholder="Volume utile (m³)"
          value={draft.VolumeUtile || ''}
          onChange={e => setDraft({ ...draft, VolumeUtile: Number(e.target.value) })}
        />
        <button className={styles.btnPrimary} onClick={handleAdd}>Ajouter</button>
      </div>
      <table className={styles.table}>
        <thead>
          <tr><th>Bac</th><th>Dépôt</th><th>Vol. (m³)</th><th>Restriction</th><th>Actions</th></tr>
        </thead>
        <tbody>
          {filtered.map(b => (
            <tr key={b.Id}>
              <td>{b.Title}</td>
              <td>{b.DepotTitle}</td>
              <td>{b.VolumeUtile?.toLocaleString('fr-FR')}</td>
              <td>{b.RestrictionClients ? `${Math.round(b.RestrictionClients * 100)}%` : ''}</td>
              <td>
                <button className={styles.btnSmallDanger} onClick={() => handleDelete(b.Id)}>
                  Supprimer
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
